import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home'
import Index from '@/components/index'
import About from '@/components/about' //关于我们
import Nocice from '@/components/notice' //通告列表
import Industry from '@/components/Industry'
import Msg from '@/components/msg'  //通告详情
import processes from '@/components/processes' //流程
import Bind from '@/components/bindphone'
//医院注册审核
import Hosp from '@/administrators/hospitalaudit'
import Hosps from '@/administrators/hostla'
import Compa from '@/administrators/companyaudit'
import Crcau from '@/administrators/crcaudit'
import Information from '@/administrators/company-means'
import Assignment from '@/administrators/user-menas'
// 医院路由company
import Hlogin from '@/hospital/login'
import Hregister from '@/hospital/register'
import HIndex from '@/hospital/index'
import Hhome from '@/hospital/home'   //医院首页
import Hitem from '@/hospital/itemmsg' //接收人员页面
import Happraise from '@/hospital/appraise' //评价
import Hit from '@/hospital/items' //查看
import Hperson from '@/hospital/person-mange' //人员管理
import Hstatistics from '@/hospital/statistics' //统计页面
import Hmeans from '@/hospital/hospital-means' //医院信息
import Huser from '@/hospital/user-menas' //权限
// 公司路由
import Clogin from '@/company/login'
import Cregister from '@/company/register'
import CIndex from '@/company/index'
import Chome from '@/company/home'    //公司首页
import Cperson from '@/company/person-mange' //人员管理
import Cstatistics from '@/company/statistics' //统计页面
import Cappoint from '@/company/appoint' //委派
import Cwait from '@/company/wait-reception' //待接收
import Cmeans from '@/company/company-means' //公司信息
import Cuser from '@/company/user-menas' //权限
import Caddperson from '@/company/addperson' //新增人员页面
// 用户路由
import Plogin from '@/person/login'
import Phome from '@/person/home'
Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: '/about',
          name: 'About',
          component: About
        },
        {
          path: '/notice/:id',
          name: 'Nocice',
          component: Nocice
        },
        {
          path: '/Industry',
          name: 'Industry',
          component: Industry
        },
        {
          path: '/Msg/:id',
          name: 'Msg',
          component: Msg
        },
        {
          path: '/processes',
          name: 'processes',
          component: processes
        }
      ]
    },
    {
      path: '/Bind',
      name: 'Bind',
      component: Bind
    },
    //医院审核注册
    {
      path: '/hospitalaudit',
      name: 'Hosp',
      component: Hosp,
      children: [
        {
          path: '/hospitalaudit/hostla',
          name: 'Hosps',
          component: Hosps,
        },
        {
          path: '/hospitalaudit/companyaudit',
          name: 'Compa',
          component: Compa,
        },
        {
          path: '/hospitalaudit/crcaudit',
          name: 'Crcau',
          component: Crcau,
        },
        {
          path: '/hospitalaudit/company-means',
          name: 'Information',
          component: Information
        },
        {
          path: '/hospitalaudit/user-menas',
          name: 'Assignment',
          component: Assignment
        }
      ]
    },
    {
      path: '/login-company',
      name: 'Clogin',
      component: Clogin
    },
    {
      path: '/login-hospital',
      name: 'Hlogin',
      component: Hlogin
    },
    {
      path: '/login-person',
      name: 'Plogin',
      component: Plogin
    },
    {
      path: '/person-home',
      name: 'Phome',
      component: Phome
    },
    // 医院路由
    {
      path: '/HIndex',
      name: 'HIndex',
      component: HIndex,
      redirect: '/HIndex/hostipal-home',
      children: [
        {
          path: 'hostipal-home',
          name: 'Hhome',
          component: Hhome
        },
        {
          path: 'hostipal-item/:id',
          name: 'Hitem',
          component: Hitem
        },
        {
          path: 'hostipal-items/:id',
          name: 'Hit',
          component: Hit
        },
        {
          path: 'hostipal-appraise/:id',
          name: 'Happraise',
          component: Happraise
        },
        {
          path: 'hostipal-person',
          name: 'Hperson',
          component: Hperson
        },
        {
          path: 'hostipal-statistics',
          name: 'Hstatistics',
          component: Hstatistics
        },
        {
          path: 'hostipal-means',
          name: 'Hmeans',
          component: Hmeans
        },
        {
          path: 'user-means',
          name: 'Huser',
          component: Huser
        }
      ]
    },
    // 医院注册
    {
      path: '/register-hostipal',
      name: 'Hregister',
      component: Hregister
    },
    // 公司注册
    {
      path: '/register-company/:id/:userid',
      name: 'Cregister',
      component: Cregister
    },
    // 公司
    {
      path: '/CIndex',
      name: 'CIndex',
      component: CIndex,
      redirect: '/CIndex/company-home',
      children: [
        {
          path: 'company-home',
          name: 'Chome',
          component: Chome
        },
        {
          path: 'company-person',
          name: 'Cperson',
          component: Cperson
        },
        {
          path: 'company-statistics',
          name: 'Cstatistics',
          component: Cstatistics
        },
        {
          path: 'company-appoint/:projectId',
          name: 'Cappoint',
          component: Cappoint
        },
        {
          path: 'wait-reception/:projectId',
          name: 'Cwait',
          component: Cwait
        },
        {
          path: 'company-means',
          name: 'Cmeans',
          component: Cmeans
        },
        {
          path: 'company-user',
          name: 'Cuser',
          component: Cuser
        },
        {
          path: 'addperson',
          name: 'Caddperson',
          component: Caddperson
        }
      ]
    },
    // 公司
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js